import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy } from '@angular/core';

@Directive({
  selector: '[oesAgHorizontalScroll]'
})
export class AgHorizontalScrollDirective implements AfterViewInit, OnDestroy {
  private isDown = false;
  private startX: number;
  private scrollLeft: number;
  private target: any;
  private observer: MutationObserver;

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    this.findTargetElement();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private findTargetElement() {
    this.target = this.el.nativeElement.querySelector('.ag-center-cols-viewport');
    this.listenDomChanges();
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    // Try to find target again if not found yet (for server-side models)
    if (!this.target) {
      this.findTargetElementServerSideGrid();
      return;
    }

    const targetRect = this.target.getBoundingClientRect();
    const cursorOverTarget =
      event.clientX >= targetRect.left &&
      event.clientX <= targetRect.right &&
      event.clientY >= targetRect.top &&
      event.clientY <= targetRect.bottom;
    if (!cursorOverTarget) {
      return;
    }
    this.isDown = true;
    this.startX = event.pageX - this.target.offsetLeft;
    this.scrollLeft = this.target.scrollLeft;
    this.target.style.cursor = 'grabbing';
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.target) {
      this.findTargetElementServerSideGrid();
      return;
    }

    this.target.style.cursor = 'grab';
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (!this.target) {
      this.findTargetElementServerSideGrid();
      return;
    }

    this.isDown = false;
    this.target.style.cursor = 'grab';
  }

  @HostListener('mouseup')
  onMouseUp() {
    if (!this.target) {
      this.findTargetElementServerSideGrid();
      return;
    }

    this.isDown = false;
    this.target.style.cursor = 'grab';
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.target || !this.isDown) {
      return;
    }
    event.preventDefault();
    const x = event.pageX - this.target.offsetLeft;
    const walk = (x - this.startX) * 3; // The multiplier speeds up scrolling
    this.target.scrollLeft = this.scrollLeft - walk;
  }

  private listenDomChanges() {
    if (!this.target) {
      // Use MutationObserver to watch for DOM changes (for server-side grid models)
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && !this.target) {
            this.target = this.el.nativeElement.querySelector('.ag-center-cols-viewport');

            if (this.target) {
              this.observer.disconnect();
            }
          }
        });
      });

      this.observer.observe(this.el.nativeElement, {
        childList: true,
        subtree: true
      });
    }
  }

  private findTargetElementServerSideGrid() {
    this.target = this.el.nativeElement.querySelector('.ag-center-cols-viewport');
  }
}
